import React from 'react'
import PropTypes from 'prop-types'
import Button from '../Button'
import { StyledButtonBarBtn } from './atoms'
import { Form } from '@entrata/portals-common/lib/components/forms'

import { css } from '@emotion/core'

const StaticButtonBar = ({ buttonText, spacing }) => (
  <Form.Actions
    render={() => (
      <div
        css={css`
          display: flex;
          justify-content: center;
          margin-top: ${spacing || '24px'};
          di
        `}
      >
        <StyledButtonBarBtn appearance='primary' type='submit' size='large'>
          {buttonText}
        </StyledButtonBarBtn>
      </div>
    )}
  />
)

StaticButtonBar.propTypes = {
  buttonText: PropTypes.string.isRequired,
  spacing: PropTypes.string,
}

export default StaticButtonBar
